import { render, staticRenderFns } from "./BackgroundPositionSetting.vue?vue&type=template&id=9c0d69c2"
import script from "./BackgroundPositionSetting.vue?vue&type=script&lang=js"
export * from "./BackgroundPositionSetting.vue?vue&type=script&lang=js"
import style0 from "./BackgroundPositionSetting.vue?vue&type=style&index=0&id=9c0d69c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VBtnToggle,VIcon,VSlider})
